package music.jammers.client.shared.admin.presentation.ui

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import limasoul.client.shared.generated.resources.Res
import limasoul.client.shared.generated.resources.admin_screen_title
import music.jammers.client.shared.admin.di.AdminComponent
import music.jammers.client.shared.admin.presentation.model.SettingItem
import music.jammers.client.shared.component.BackgroundBox
import music.jammers.client.shared.component.JammersTopAppBar
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource

const val ADMIN_SCREEN = "AdminScreen"

@Composable
fun AdminScreen() {
    val viewModel = remember { AdminComponent.adminViewModel.apply { onReady() } }
    val settingsList = viewModel.state.value.settingList

    Scaffold(
        topBar = {
            JammersTopAppBar(
                text = stringResource(Res.string.admin_screen_title),
                navigationIcon = {
                    IconButton(
                        onClick = viewModel::onCloseButtonClicked,
                    ) {
                        Icon(
                            imageVector = Icons.AutoMirrored.Filled.ArrowBack,
                            contentDescription = "Back",
                        )
                    }
                }
            )
        }
    ) { paddingValues ->
        BackgroundBox {
            LazyColumn(modifier = Modifier.padding(paddingValues).padding(top = 8.dp)) {
                items(settingsList) { item ->
                    Item(item) { viewModel.onClickItem(item) }
                }
            }
        }
    }
}

@Composable
private fun Item(model: SettingItem, onClick: () -> Unit) {
    val modifier = Modifier
        .fillMaxWidth()
        .padding(horizontal = 16.dp, vertical = 8.dp)
        .clickable { onClick() }

    Row(modifier) {
        Icon(
            modifier = Modifier.padding(vertical = 4.dp).size(24.dp),
            painter = painterResource(model.icon),
            contentDescription = "Item icon"
        )
        Text(
            modifier = Modifier.padding(horizontal = 8.dp).align(Alignment.CenterVertically),
            text = stringResource(model.title),
            style = MaterialTheme.typography.bodyMedium
        )
    }
}